'use client';

import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import PropertyCard from './PropertyCard';

const PropertyCarousel = ({ properties, onSave }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: 'start',
        slidesToScroll: 1,
        dragFree: true,
        containScroll: 'trimSnaps',
        loop: false,
    });

    const scrollPrev = useCallback(() => {
        if (emblaApi && emblaApi.canScrollPrev()) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi && emblaApi.canScrollNext()) emblaApi.scrollNext();
    }, [emblaApi]);

    return (
        <div className="relative group">
            {/* Carousel Container */}
            {/* Carousel Container */}
            <div className="overflow-hidden" ref={emblaRef}>
                <div className="flex -ml-4 py-4">
                    {properties.map((property) => (
                        <div
                            key={property.id}
                            className="flex-[0_0_85%] sm:flex-[0_0_40%] lg:flex-[0_0_20%] min-w-0 pl-4"
                        >
                            <div className="h-full">
                                <PropertyCard
                                    property={property}
                                    onSave={onSave}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Gradient Overlay for "Fade" effect on the right */}
            <div className="absolute top-0 right-0 h-full w-24 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none z-10 hidden lg:block" />

            {/* Navigation Buttons */}
            <button
                onClick={scrollPrev}
                className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 w-10 h-10 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center text-gray-600 hover:text-primary hover:border-primary transition-all opacity-0 group-hover:opacity-100 z-20 disabled:opacity-0 hidden lg:flex"
                aria-label="Previous slide"
            >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>

            <button
                onClick={scrollNext}
                className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 w-10 h-10 bg-white rounded-full shadow-lg border border-gray-100 flex items-center justify-center text-gray-600 hover:text-primary hover:border-primary transition-all opacity-0 group-hover:opacity-100 z-20 disabled:opacity-0 hidden lg:flex"
                aria-label="Next slide"
            >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    );
};

export default PropertyCarousel;
